export default "__VITE_ASSET__DH0Nk$Sc__"